import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Heart, ShoppingCart, Search } from "lucide-react";
import { toast } from "sonner";

export default function Products() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const load = async () => { const { data } = await api.get("/dealer/catalog", { params: search ? { search } : {} }); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [search]);

  const addToCart = async (p) => {
    try { await api.post("/dealer/cart", { product_id: p.id, qty: 1 }); toast.success(`${p.title} added to cart`); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const addWishlist = async (p) => {
    try { await api.post("/dealer/wishlist", { product_id: p.id }); toast.success("Wishlisted"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-products">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-black">Catalogue</h1>
          <p className="text-muted-foreground">Live stock and your dealer pricing tier are applied automatically.</p>
        </div>
        <div className="relative w-72">
          <Search className="w-4 h-4 absolute left-3 top-3 text-muted-foreground" />
          <Input className="pl-10" placeholder="Search products…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="prod-search" />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {items.map((p) => (
          <Card key={p.id} data-testid={`prod-card-${p.id}`} className="hover:shadow-lg transition-shadow">
            <CardContent className="p-4 space-y-2">
              {p.image_url && <img src={p.image_url} alt={p.title} className="w-full aspect-square object-cover rounded-md" />}
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold line-clamp-1">{p.title}</div>
                  <div className="text-xs text-muted-foreground">{p.size || ""} · {p.finish || ""}</div>
                </div>
                {p.category && <Badge variant="outline" className="text-[10px] shrink-0">{p.category}</Badge>}
              </div>
              <div className="flex items-baseline gap-2">
                <span className="font-display text-xl font-black text-emerald-700">₹{(p.dealer_price || 0).toLocaleString()}</span>
                {p.mrp > p.dealer_price && <span className="text-xs text-muted-foreground line-through">₹{p.mrp.toLocaleString()}</span>}
                <span className="text-[10px] text-muted-foreground">/{p.unit || "box"}</span>
              </div>
              <div className="flex items-center gap-2 pt-2">
                <Button size="sm" onClick={() => addToCart(p)} className="flex-1" data-testid={`prod-add-${p.id}`}><ShoppingCart className="w-4 h-4 mr-1" /> Add</Button>
                <Button size="sm" variant="ghost" onClick={() => addWishlist(p)} data-testid={`prod-wish-${p.id}`}><Heart className="w-4 h-4" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-muted-foreground py-16">No products match your search.</div>}
      </div>
    </div>
  );
}
